<template>
    <div class="charge_page max-content">
        <img v-if="meeting_id == 619" style="width: 100%;margin-bottom: 20px;"
            src="https://cdn.edstatic.com/203012120000/9b183c3545807f02cc87246a832dbc41/2025/09/fd149b9e-73bd-4540-be41-f7222949195c.png"
            alt="">
        <img v-if="meeting_id == 819" style="width: 100%;margin-bottom: 20px;"
            src="//cdn.edstatic.com/203012120000/90590324dd86839bd795a7392942d31b/2026/09/8772ca39-636d-4212-b6a0-f563862393cc.webp"
            alt="">
        <div class="charge_info">
            <p style="color:#901D22">注册费用信息：</p>
            <p v-if="meeting_id == 508">线下参会注册费用1000元/人 （费用包括：10月16日午餐和晚餐、10月17日午餐以及会议期间茶歇，并且可以现场领取会议资料包。不含交通及住宿费用）</p>
            <p v-else-if="meeting_id == 627">
                线下参会注册费用1000元/人（费用包括：11月12日午餐和晚餐、11月13日午餐以及会议期间茶歇，并且可以现场领取会议资料包。不含交通及住宿费用）</p>

            <div v-else-if="meeting_id == 816">
                <p>1.线下参会注册费用1000元/人</p>
                <p>2.会议注册费包含：2026年10月14日午餐和晚餐、2026年10月15日午餐以及会议期间茶歇，并且可以现场领取会议资料包。（不含交通及住宿费用）</p>
            </div>
            <p v-else>线下参会注册费用1000元/人 （包含会议资料、会议期间午餐和晚餐, 不含交通及住宿费用）</p>


        </div>
        <div class="ways" v-if="info">
            <!-- -->
            <div v-if="!show_ways && info.reg_status" style="color: #901D22;" class="status">
                <img :src="info.status == 1 ? 'https://cdn.edstatic.com/203012120000/120bb00b9a7366fb9d15ac36e8afb117/2025/09/c07cb3c2-91d8-4d46-8184-c21113bb4fa4.png' : 'https://cdn.edstatic.com/203012120000/b871c10c6158d3ca824873199b083bce/2025/09/2a7cc36e-7e48-4368-88e8-345cd9153d0e.png'"
                    alt="">
                <span>{{ info.status == 1 ? '注册成功' : '信息已提交，请等待审核' }}</span>
            </div>

            <h4 v-if="info.is_end" style="color: #901D22;">注册报名已结束</h4>
            <h4 v-if="show_ways">请选择<span>注册方式</span></h4>
            <div v-if="show_ways" class="ways_list">
                <div @click="goRegister(1)">
                    <img src="@/assets/images/Meeting/charge_xianshang.png" alt="">
                    <span>线上支付</span>
                </div>
                <div @click="goRegister(2)" v-if="meeting_id != 508 && meeting_id != 627 && meeting_id != 816">
                    <img src="@/assets/images/Meeting/charge_xianxia.png" alt="">
                    <span>公对公转账</span>
                </div>
            </div>
        </div>
        <div class="ways" v-if="meeting_id == 507">
            <h4>下载<span>邀请函</span></h4>
            <div class="ways_list">
                <div @click="downPdf(507)">
                    <img style="width: auto;" src="@/assets/images/Meeting/icon_down.png" alt="">
                    <span>下载至手机</span>
                </div>
            </div>
        </div>
        <div class="ways" v-if="meeting_id == 819">
            <h4>下载<span>邀请函</span></h4>
            <div class="ways_list">
                <div @click="downPdf(819)">
                    <img style="width: auto;" src="@/assets/images/Meeting/icon_down.png" alt="">
                    <span>下载至手机</span>
                </div>
            </div>
        </div>
        <div class="charge_info" v-if="meeting_id == 816">
            <p style="color:#901D22">重要说明：</p>
            <p>1.报名注册顺序：填写参会人信息→前往微店缴费，付款成功→录入开票信息/不录入→等待审核；</p>
            <p>2.本次会议线上注册通道时间截止至<span style="color:#901D22">2026年10月08日23:59</span>，不支持现场注册;</p>
            <p>3.会议直播免费观看，不设回放，更多信息敬请关注公众号：上海乳腺重建论坛;</p>
            <p>4.若您对注册付费有疑问，可联系组委会胡老师邮箱：jaicy.hu@edoctor.work</p>
        </div>
        <div class="charge_info" v-else-if="meeting_id == 508">
            <p style="color:#901D22">温馨提示：</p>
            <p>1.本次会议<span style="color:#901D22">线上注册通道时间截止至2024年10月10日 23:59，不支持现场注册；</span></p>
            <p>2.会议直播免费观看，不设回放，更多信息敬请关注公众号：上海乳腺重建论坛;</p>
            <p>3.若您对注册付费有疑问，可联系组委会胡老师。电话：13501720634</p>
        </div>
        <div class="charge_info" v-else-if="meeting_id == 619">
            <p style="color:#901D22">温馨提示：</p>
            <p>1.本次会议<span style="color:#901D22">线上注册通道时间截止至2025年11月15日 15:00；</span></p>
            <!-- <p>2.本次会议<span style="color:#901D22">现场注册通道时间将于2025年9月10日 0:00-11月15日 15:00 开放；</span></p> -->
            <!-- <p>3.会议直播免费观看，回看敬请关注SIBCS公众号；</p> -->
            <p>2.若您对注册付费有疑问，可联系秘书处蒋老师。电话：021-63597616、13916666715</p>
        </div>
        <div class="charge_info" v-else-if="meeting_id == 819">
            <p style="color:#901D22">温馨提示：</p>
            <p>1.线上注册通道截止时间:<span style="color:#901D22">2026年10月17日 12:00 </span></p>
            <p>2.若您对注册付费有疑问，可联系秘书处蒋老师。电话：021-63597616、13916666715</p>
        </div>
        <div class="charge_info" v-else>
            <p style="color:#901D22">温馨提示：</p>
            <p>1.本次会议<span style="color:#901D22">线上注册通道时间截止至2025年11月07日 23:59，不支持现场注册</span>；</p>
            <p>2.会议直播免费观看，不设回放，更多信息敬请关注公众号：上海乳腺重建论坛;</p>
            <p>3.若您对注册付费有疑问，可联系组委会胡老师。电话：13501720634</p>
        </div>

        <div class="charge_info">
            <p style="color: #901D22;">开票注意事项：</p>
            <p>1. 请务必填写正确的开票信息：</p>
            <p>（1）企业发票：<span style="color: #901D22;"> 抬头必须为实际参会人单位</span>;</p>
            <p>（2）个人发票：<span style="color: #901D22;"> 抬头必须为实际参会人姓名</span>;</p>
            <p>2.发票为 <span style="color: #901D22;">电子增值税普通发票</span>，请务必填写正确的邮箱以免收不到；</p>
            <p v-if="meeting_id == 508 || meeting_id == 627 || meeting_id == 816 || meeting_id == 819">3.发票将于 <span
                    style="color: #901D22;">会议结束后45个工作日内由【上海抗癌协会】开具</span>。
            </p>
            <p v-else>3.发票将于 <span style="color: #901D22;">会议结束后45个工作日内开具</span>。</p>
        </div>
        <!-- <div class="charge_info" v-else>
            <p style="color:#901D22">开票注意事项：</p>
            <p>1.请务必填写正确的开票信息，<span style="color:#901D22">企业发票，抬头需和参会人单位保持一致</span>； 个人发票，抬头需和参会人姓名保持一致;</p>
            <p>2.发票为<span style="color:#901D22">电子增值税普通发票</span> ，请务必填写正确的邮箱以免收不到；</p>
            <p>3.发票将于<span style="color:#901D22">会议结束后45个工作日内【由上海市抗癌协会】开具</span>。</p>

        </div> -->
        <div class="charge_info" v-if="meeting_id == 819">
            <p style="color:#901D22">退款须知：</p>
            <p>1.<span style="color:#901D22">退款截止日期：10月13日 23:59前，过时不予退款。</span></p>
            <p>2. 如需退款，步骤如下:</p>
            <p>（1）发送邮件至秘书处蒋老师，邮箱：susan@sibcs.com</p>
            <p>（2）邮件标题：<span style="color: #901D22;"> 第十九届全国乳腺癌学术会议注册退款 </span></p>
            <p>（3）<span style="color: #901D22;">正文和附件提供：参会者单位、姓名、手机、微信支付凭证截图或银行转账记录</span> （点击[我]-[服务]-[钱包]-右上角[账单]-付款详情，截图需要露出交易号）</p>
        </div>
        <div class="charge_info" v-else-if="meeting_id == 816">
            <p style="color:#901D22">退款须知：</p>
            <p>1.线上退款通道于至<span style="color:#901D22">2026年10月08日23:59</span>关闭。如需退款可邮箱联系组委会胡老师邮箱：jaicy.hu@edoctor.work
            </p>
            <p>2.<span style="color:#901D22">10月08日后注册通道关闭且注册费不予退还</span> </p>
            <p>3.退款邮件需提供：参会者单位、姓名、手机、订单截图（下载APP【微店】/搜索小程序【微店买买】-【我的】-【我的订单】-【查看更多】-【点击对应订单】，截图需要露出订单号）</p>
        </div>
        <div class="charge_info" v-else-if="meeting_id == 508">
            <p style="color:#901D22">退款须知：</p>
            <p>1.线上<span style="color:#901D22">退款通道于至10月13日23:59关闭</span>。</p>
            <p>2.如需退款可邮箱联系组委会胡老师邮箱：jaicy.hu@edoctor.cn。<span style="color:#901D22">退款需要提供：</span>
                参会者单位、姓名、手机、支付凭证截图（点击[我]-[服务]-[钱包]-右上角[账单]-付款详情，截图需要露出交易号）</p>
        </div>
        <div class="charge_info" v-else-if="meeting_id == 627">
            <p style="color:#901D22">退款须知：</p>
            <p>1.线上<span style="color:#901D22">退款通道于至11月07日23:59关闭</span>。</p>
            <p>2.如需退款可邮箱联系组委会胡老师邮箱：jaicy.hu@edoctor.cn。<span style="color:#901D22">退款需要提供：</span>
                参会者单位、姓名、手机、支付凭证截图（点击[我]-[服务]-[钱包]-右上角[账单]-付款详情，截图需要露出交易号）</p>
        </div>
        <div class="charge_info" v-else>
            <p style="color:#901D22">退款须知：</p>
            <p v-if="meeting_id == 619">1.线上<span style="color:#901D22">退款通道于至11月15日 15:00关闭</span>。</p>
            <p v-else>1.线上<span style="color:#901D22">退款通道于至10月10日23:59关闭</span>。</p>
            <p>2.如需退款可邮箱联系秘书处蒋老师邮箱：susan@sibcs.com。<span style="color:#901D22">退款需要提供：</span>
                参会者单位、姓名、手机、支付凭证截图（点击[我]-[服务]-[钱包]-右上角[账单]-付款详情，截图需要露出交易号）</p>
        </div>
        <div class="bottom" v-if="info && !info.is_end && !show_ways">
            <div class="btn" @click="navToList">我的报名</div>
            <div class="btn" @click="againClick">再填一个</div>
        </div>
    </div>

</template>

<script>
import { MeetingRegInfo } from '../../../config/interface.js'
import { Dialog } from 'vant';
export default {
    data() {
        return {
            info: null,
            show_ways: true,
            isNew: 0,
            pdf_url: ''
        }
    },
    computed: {
        meeting_id() {
            return this.$route.query.meeting_id ? this.$route.query.meeting_id : (this.$route.query.id ? this.$route.query.id : this.$route.query.MT_id);
        }
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        goRegister(val) {

            common.confirm('提示', '注册方式一旦选择无法修改，是否确认下一步？', () => {
                if (this.info) { //	1线上2线下
                    this.$router.replace({
                        path: "/vascularNews/chargeInfo/collectInfo",
                        query: { type: val, step: this.info.step, meeting_id: this.meeting_id, isNew: this.isNew }
                    });
                }
            })


        },
        getDetail() {
            const url = MeetingRegInfo;
            let params = {
                meeting_id: this.meeting_id,
            }
            const method = "get";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.info = res.data

                        if (this.info.step <= 3 && this.info.step > 1 && !this.info.is_end) {
                            this.$router.replace({
                                path: "/vascularNews/chargeInfo/collectInfo",
                                query: { type: res.data.type_id, step: res.data.step, meeting_id: this.meeting_id }
                            });
                            return;
                        }
                        if (res.data.status == 1 || (res.data.status == 0 && res.data.reg_status == 1) || this.info.is_end) {
                            this.show_ways = false;
                            return;
                        }


                    }
                })
        },
        againClick() {
            this.show_ways = true;
            this.info.step = 1;
            this.isNew = 1

        },
        navToList() {
            this.$router.push({
                path: '/vascularNews/chargeInfo/historyList?meeting_id=' + this.meeting_id
            })
        },
        downPdf(val) {
            if (val == 507) {
                this.pdf_url = 'http://www.sibcs.com/upload/sibcs2024.pdf'
            } else if (val == 819) {
                this.pdf_url = 'https://cdn.edstatic.com/203012120000/a377466c7fd54f321bad692d72944fca/2026/09/fad79253-add0-47fe-8f11-3bc6c680609d.pptx'
            }
            window.open(this.pdf_url)
            // var u = navigator.userAgent, app = navigator.appVersion;
            // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            // if (isAndroid) {
            //     window.location.href = this.pdf_url;
            // }else
            // if (isIOS) {
            //     Dialog.alert({
            //         message: 'IOS系统用户如需下载请点击页面右上角“···”跳转到浏览器进行下载',
            //     }).then(() => {
            //         window.location.href = this.pdf_url;
            //     });
            // }

        },
    }
}
</script>

<style lang="scss" scoped>
.charge_page {
    width: 100%;
    padding: 15px;
    background: #fff;

    .charge_info {
        color: #666;
        font-size: 13px;
        font-family: PingFang SC;
        line-height: 22px;
        margin-bottom: 20px;

    }

    .ways {
        .status {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 30px;

            img {
                width: 120px;
            }

        }

        h4 {
            display: flex;
            font-size: 18px;
            margin-bottom: 10px;

            span {
                display: block;
                height: 20px;
                border-bottom: 5px solid #FFBFBF;
            }
        }

        .ways_list {
            display: flex;
            justify-content: space-between;
            align-content: center;
            margin-top: 20px;
            margin-bottom: 30px;
            gap: 15px;

            >div {
                width: 165px;
                height: 72px;
                background: #FFF3F3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                border-radius: 5px;

                img {
                    width: 22px;
                    height: 22px;
                    margin-right: 20px;

                }

            }
        }
    }

}

.bottom {
    margin: 30px auto 0;
    display: flex;
    justify-content: center;
    gap: 20px;

    .btn {
        width: 165px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        color: #fff;
        border-radius: 5px;
        background: #901D22;
        font-size: 16px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/ChargeInfo/index.vue